import React from 'react';
import GlobalContext from './contexts/GlobalContext';
import { Flag } from 'semantic-ui-react';
import Moment from 'moment';
import imgEmpty from './assets/empty.jpg';
import imgEmptyCardDashboard from './assets/emptyCardDashboard.jpg';
import { config } from './Config';
import API from './API';

// Neutral token path segment: the session is carried by the HttpOnly cookie.
const NEUTRAL_TOKEN_SEGMENT = '-';
// Booking engine handoff code: 128 bits in lowercase hexadecimal.
const HANDOFF_CODE_PATTERN = /^[0-9a-f]{32}$/;
// Past this delay the handoff issue gives up and the opened tab loads the anonymous link.
const HANDOFF_REQUEST_TIMEOUT_MS = 5000;

class Utility {

  static contextType = GlobalContext;

  // True while a handoff code is issued: the server keeps a single nonce cookie, a concurrent issue would overwrite it.
  bookingEngineHandoffPending = false;

  /**
   * Met le premier caractère en majuscule
   * @param {string} s
   * @return {string}
   */
  ucFirst(s) {
    if (typeof s !== 'string') return ''
    return s.charAt(0).toUpperCase() + s.slice(1)
  }

  /**
   * Met le premier caractère en minuscule
   * @param {string} s
   * @return {string}
   */
  lcFirst(s) {
    if (typeof s !== 'string') return ''
    return s.charAt(0).toLowerCase() + s.slice(1)
  }

  /**
   * Met le string en minuscule 
   * @param {string} s
   * @return {string}
   */
  lowerCase(s) {
    if(typeof s === 'string') {
      s = s.toLowerCase();
    }
    return s;
  }
  
  /**
   * Met le string en majuscule 
   * @param {string} s
   * @return {string}
   */
  upperCase(s) {
    if(typeof s === 'string') {
      s = s.toUpperCase();
    }
    return s;
  }

  /**
   * Retourne le pattern en fonction de la demande
   * @param {string} typePattern 
   * @reutrn {string} pattern
   */
  getPattern(typePattern) {
    let pattern;
    switch (typePattern) {
      case 'mail':
        pattern = "/[a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+.[a-zA-Z.]{2,15}/";
        break;
      case 'password':
        // eslint-disable-next-line no-useless-escape
        pattern = "/(?=^.{8,}$)((?=.*\d)|(?=.*\W+))(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$/";
        break;
      case 'name':
        pattern = "/[a-zA-Z0-9]+{1,30}$/";
        break;
      case 'string':
        // eslint-disable-next-line no-useless-escape
        pattern = "/^[a-zA-Z][a-zA-Z0-9-_\.]{1,30}$/";
        break;
      case 'notNull':
        pattern = "/^char()$/";
        break;
      default:
        pattern = null;
        break;
    }
    return pattern;
  }

  getSiteMap(translations={}) {
    return {
      'account': {
        codePage: 'account',
        header: (translations.myAccount) ? translations.myAccount : null,
        subHeader: (translations.myAccount) ? translations.myAccount : null,
        icon: 'user',
        url : '/account',
        color: 'blue',
        breadcrumb: false
      },
      'connectionAndSetting': {
        codePage: 'connectionAndSetting',
        header: (translations.connectionAndSetting) ? translations.connectionAndSetting : null,
        subHeader: (translations.detailConnectionAndSetting) ? translations.detailConnectionAndSetting : null,
        icon: 'lock',
        url : '/account/connectionAndSetting',
        color: 'red',
        breadcrumb: false
      },
      'personalInformation': {
        codePage: 'personalInformation',
        header: (translations.myPersonalInformation) ? translations.myPersonalInformation : null,
        subHeader: (translations.detailMyPersonalInformation) ? translations.detailMyPersonalInformation : null,
        icon: 'address book',
        url : '/account/personalInformation',
        color: 'red',
        breadcrumb: false
      },
      'addressCP': {
        codePage: 'addressCP',
        header: (translations.addressCP) ? translations.addressCP : null,
        subHeader: (translations.detailAddressCP) ? translations.detailAddressCP : null,
        icon: 'address card',
        url : '/account/addressCP',
        color: 'green',
        breadcrumb: false
      },
      'additionalInformation': {
        codePage: 'additionalInformation',
        header: (translations.additionalInformation) ? translations.additionalInformation : null,
        subHeader: (translations.additionalInformation) ? translations.detailAdditionalInformation : null,
        icon: 'clipboard',
        url : '/account/additionalInformation',
        color: 'blue',
        breadcrumb: false
      },
      'deleteAccount': {
        codePage: 'deleteAccount',
        header: (translations.deleteAccount) ? translations.deleteAccount : null,
        subHeader: (translations.dashbdeleteAccountoard) ? translations.detailDeleteAccount : null,
        icon: 'delete',
        url : '/account/deleteAccount',
        color: 'blue',
        breadcrumb: false
      },
      'checkin': {
        codePage: 'checkin',
        header: (translations.formulaireCheckIn) ? translations.formulaireCheckIn : null,
        subHeader: (translations.detailFormulaireCheckIn) ? translations.detailFormulaireCheckIn : null,
        icon: 'camera',
        url : '/checkin',
        color: 'grey',
        breadcrumb: false
      },
      'preCheckIn': {
        codePage: 'checkin',
        header: (translations.formulaireCheckIn) ? translations.formulaireCheckIn : null,
        subHeader: (translations.detailFormulaireCheckIn) ? translations.detailFormulaireCheckIn : null,
        icon: 'camera',
        url : '/preCheckIn',
        color: 'grey',
        breadcrumb: false
      },
      'checkinV2': {
        codePage: 'checkinV2',
        header: (translations.formulaireCheckIn) ? translations.formulaireCheckIn : null,
        subHeader: (translations.detailFormulaireCheckIn) ? translations.detailFormulaireCheckIn : null,
        icon: 'camera',
        url : '/checkinV2',
        color: 'grey',
        breadcrumb: false
      },
      'dashboard': {
        codePage: 'dashboard',
        header: (translations.dashboardEspaceClient) ? translations.dashboardEspaceClient : null,
        subHeader: (translations.detailDashboard) ? translations.detailDashboard : null,
        icon: 'home',
        url : '/',
        color: 'orange',
        breadcrumb: false
      },
      'bookings': {
        codePage: 'bookings',
        header: (translations.bookings) ? translations.bookings : null,
        subHeader: (translations.detailBookings) ? translations.detailBookings : null,
        icon: 'hotel',
        url : '/bookings',
        color: 'orange',
        breadcrumb: false
      },
      'establishment': {
        codePage: 'establishment',
        header: (translations.establishment) ? translations.establishment : null,
        subHeader: (translations.detailEstablishment) ? translations.detailEstablishment : null,
        icon: 'building',
        url : '/establishment',
        color: 'orange',
        breadcrumb: false
      },
      'panier': {
        codePage: 'panier',
        header: (translations.myBasket) ? translations.myBasket : null,
        subHeader: (translations.detailMyBasket) ? translations.detailMyBasket : null,
        icon: 'shop',
        url : '/panier',
        color: 'orange',
        breadcrumb: false
      },
      'notif': {
        codePage: 'notif',
        header: (translations.myBasket) ? translations.myBasket : null,
        subHeader: (translations.detailMyBasket) ? translations.detailMyBasket : null,
        icon: 'alarm',
        url : '/notif',
        color: 'orange',
        breadcrumb: false
      }
    };
  }

  /**
   * Builds the AJAX path.
   * @param {string|null} url
   * @return {string}
   */
  getUrlAjax(url = null) {
    const apiUrl = `/${this.getSessionTokenSegment()}/${localStorage.getItem('lang')}`;
    if (url) {
      return `${apiUrl}/${url}`;
    }

    return apiUrl;
  }

  /**
   * Token path segment: password sessions rely on the HttpOnly cookie ("-");
   * link sessions send the route token, already in the page URL (cookie may be blocked in a third-party iframe).
   * The non-secret flag of the current tab is read directly to avoid an Auth/Utility circular import.
   * @return {string}
   */
  getSessionTokenSegment() {
    if (sessionStorage.getItem('authViaPassword') === 'true') {
      return NEUTRAL_TOKEN_SEGMENT;
    }
    const routeToken = this.getRouteToken();

    return routeToken !== null ? routeToken : NEUTRAL_TOKEN_SEGMENT;
  }

  /**
   * Token path segment of a call bound to a temporary link returned by the server (e.g. initializePassword):
   * the link token when usable, otherwise the session segment of the tab (never "undefined").
   * @param {*} temporaryLinkToken
   * @return {string}
   */
  getTemporaryLinkTokenSegment(temporaryLinkToken) {
    return this.isValidToken(temporaryLinkToken) ? temporaryLinkToken : this.getSessionTokenSegment();
  }

  /**
   * Token for the password step once the e-mail code is verified: the link issued by the server (newToken)
   * when present, otherwise the current link (e.g. an initializePassword link received by e-mail).
   * @param {*} newToken
   * @param {string} currentToken
   * @return {string}
   */
  getPasswordStepToken(newToken, currentToken) {
    return this.isValidToken(newToken) ? newToken : currentToken;
  }

  /**
   * E-mail verification code entered by the customer (FormData value, null when the field is absent).
   * @param {*} code
   * @return {boolean}
   */
  isVerificationCodeFilled(code) {
    return typeof code === 'string' && code.trim() !== '';
  }

  /**
   * @param {*} token
   * @return {boolean}
   */
  isValidToken(token) {
    return typeof token === 'string' && token !== '' && token !== 'undefined' && token !== 'null';
  }

  /**
   * Reads the token from the current page route (/{token}/{lang}/...).
   * @return {string|null}
   */
  getRouteToken() {
    let pathname = window.location.pathname;
    if (pathname.indexOf(config.url.BASENAME) === 0) {
      pathname = pathname.substring(config.url.BASENAME.length);
    }
    const token = pathname.split('/').find(segment => segment !== '');

    return this.isValidToken(token) ? token : null;
  }

  /**
   * Direct booking engine link (no session token).
   * @param {string} bookingEngineId
   * @param {string} lang booking engine language
   * @return {string}
   */
  getBookingEngineUrl(bookingEngineId, lang) {
    return `${config.url.BOOKING_ENGINE}?id_etab=${encodeURIComponent(bookingEngineId)}&langue=${encodeURIComponent(lang)}`;
  }

  /**
   * Props of a direct booking engine link: the href stays anonymous, the click tries the handoff.
   * @param {string} bookingEngineId
   * @param {string} anonymousUrl
   * @return {{rel: string, onClick: function(!Event): (Promise<void>|undefined)}}
   */
  getBookingEngineLinkProps(bookingEngineId, anonymousUrl) {
    return {
      rel: 'noopener noreferrer',
      onClick: (event) => this.openBookingEngine(event, bookingEngineId, anonymousUrl),
    };
  }

  /**
   * Opens the booking engine signed in for a password session, through a one-time handoff code.
   * The tab is opened synchronously (popup blocker); a blocked tab, a link session, a modified or non-primary click
   * and a click during a pending issue keep the native anonymous link, a failed or timed out request loads the
   * anonymous URL in the opened tab. The request timeout bounds the pending issue lock.
   * @param {!MouseEvent} event click on a link whose href is anonymousUrl
   * @param {string} bookingEngineId
   * @param {string} anonymousUrl
   * @return {Promise<void>|undefined} pending handoff, undefined when the native navigation is kept
   */
  openBookingEngine(event, bookingEngineId, anonymousUrl) {
    if (!this.isBookingEngineHandoffAllowed(event, bookingEngineId)) {
      return undefined;
    }
    const engineWindow = window.open('', '_blank');
    if (engineWindow === null) {
      return undefined;
    }
    event.preventDefault();
    engineWindow.opener = null;
    this.bookingEngineHandoffPending = true;

    return this.requestBookingEngineHandoffCode(bookingEngineId).then((handoffCode) => {
      this.bookingEngineHandoffPending = false;
      if (engineWindow.closed === true) {
        return;
      }
      engineWindow.location.replace(
          handoffCode !== null ? `${anonymousUrl}&customerAreaHandoff=${handoffCode}` : anonymousUrl);
    });
  }

  /**
   * @param {!MouseEvent} event
   * @param {string} bookingEngineId
   * @return {boolean} true when the click may be replaced by a handoff
   */
  isBookingEngineHandoffAllowed(event, bookingEngineId) {
    return !this.bookingEngineHandoffPending
        && !this.isModifiedOrSecondaryClick(event)
        && sessionStorage.getItem('authViaPassword') === 'true'
        && this.isValidToken(bookingEngineId);
  }

  /**
   * @param {!MouseEvent} event
   * @return {boolean} true for a click whose native behavior must be kept (new background tab, window, download)
   */
  isModifiedOrSecondaryClick(event) {
    return event.button !== 0 || event.ctrlKey === true || event.metaKey === true || event.shiftKey === true
        || event.altKey === true;
  }

  /**
   * Requests a handoff code; any failure, timeout included, resolves to null, silently (no toast, no login
   * redirection).
   * @param {string} bookingEngineId
   * @return {!Promise<?string>}
   */
  requestBookingEngineHandoffCode(bookingEngineId) {
    return API
        .post(
            this.getUrlAjax('bookingEngineHandoffIssueAction'),
            new URLSearchParams({bookingEngineId}),
            {timeout: HANDOFF_REQUEST_TIMEOUT_MS})
        .then((response) => this.extractHandoffCode(response))
        .catch(() => null);
  }

  /**
   * @param {*} response
   * @return {?string} the code of a successful response, null otherwise
   */
  extractHandoffCode(response) {
    const body = response?.data;
    const handoffCode = body?.data?.code;
    if (body?.success !== true || typeof handoffCode !== 'string' || !HANDOFF_CODE_PATTERN.test(handoffCode)) {
      return null;
    }

    return handoffCode;
  }

  getUrlBaseName() {
    return `/${this.getRouteToken()}/${localStorage.getItem('lang')}`;
  }

  getUrlPage(context, codePage) {
    let siteMap = this.getSiteMap(context.translations);
    return this.getUrlBaseName() + siteMap[codePage].url;
  }

  getIconPage(code) {
    code = this.lcFirst(code);
    let siteMap = this.getSiteMap({});
    return siteMap[code].icon;
  }

  getHeaderPage(code, translations) {
    //Data
    code = this.lcFirst(code);
    let objDefault = {
      header: code,
      icon: '',
      url: ''
    }
    if(translations) {
      let listTitle = this.getSiteMap(translations);
      return (listTitle[code]) ? listTitle[code] : objDefault;
    } else {
      return objDefault;
    }
  }

  checkValue(name, data, typePattern) {
    let obj = {
      target: name,
      value: data,
      error: false
    }

    if (typePattern) {
      if(typeof data === 'string') {
        data = data.trim();
      }
      switch (typePattern) {
        case 'notNull':
          if (data === '') {
            obj.error = true;
          }
          break;
        case 'date':
          if (data === '' || data === '0000-00-00') {
            obj.error = true;
          } else {
            let date = new Moment(data);
            obj.error = !date.isValid();
          }
          break;
        case 'notNullSelectPays':
          if (data === '' || data === '00' || data === 0) {
            obj.error = true;
          }
          break;
        case 'password':
          if (data === '') {
            obj.error = true;
          } else {
            let regex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})");
            obj.error = !regex.test(data);
          }
          break;
        case 'email': 
          if (data === '') {
            obj.error = true;
          } else {
            // eslint-disable-next-line 
            let regex = new RegExp(/(?!.*\.{2})^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i);
            obj.error = !regex.test(data.toLowerCase());
          }
          break;
        default:
          obj.error = false;
      }

    }

    // let regex = Utility.getPattern(pattern);

    // error: (regex === null) ? ((data !== '') ? false : true) : data.toString().match(regex)

    return obj;
  }

  getTrad(code) {
    return code;
  }

  getBaseUrl() {
    return "/secure-direct-hotel-booking/customer"
  }


  testFlag(isoFlag) {
    let res = false;
    if(['gg','eo','im','je','su','ac','yu','aq','tp','00','mk','ss','sx','bl','mf'].indexOf(isoFlag) === -1) {
      res = true;
    }
    return res;
  }

  static listTelephoneCode;
  
  getListTelephoneCode(globalContext) {
    if(this.listTelephoneCode === undefined || this.listTelephoneCode.length === 0) {
      if (Array.isArray(globalContext.countries) === true) {
        this.listTelephoneCode = [];
        let temp = [];
        for (let i = 0; i < globalContext.countries.length; i++) {
          if(globalContext.countries[i].telephoneCode !== "") {
            let telephoneCode = parseInt(globalContext.countries[i].telephoneCode);
            if(temp[telephoneCode] === undefined) {
              temp[telephoneCode] = [];
            }
            temp[telephoneCode].push(globalContext.countries[i]);
          }
        }
        
        for(let telephoneCode in temp) {// eslint-disable-line no-unused-vars
          if(temp[telephoneCode] !== undefined) {
            for(let pays of temp[telephoneCode]) {// eslint-disable-line no-unused-vars
              if(pays && pays.id) {
                let KeyTemp = pays.telephoneCode + '__' + pays.iso,
                    iso = pays.iso.toLowerCase();

                let countryName = pays.name;

                if(this.testFlag(iso) === true) {
                  this.listTelephoneCode.push({
                    key: KeyTemp,
                    //flag: iso,
                    text: [<Flag name={iso} key={KeyTemp + 'Flag'} />, <span key={KeyTemp+'Span'}>+{pays.telephoneCode}</span>],
                    //text: countryName,
                    value: KeyTemp,
                  });
                }
              }
            };
          }
        };
      } else {
        this.listTelephoneCode = [];
      }
    }

    return this.listTelephoneCode;
  }

  getPaginationData(searchedState, maxPerPage, totalPage) {
    let filtredData = [];

    if(searchedState.length > maxPerPage) {
      let i=0;
      let y=1;
      let tempTab = [];
      searchedState.forEach(booking => {
          i++;
          tempTab.push(booking);
          if(i === maxPerPage) {
              filtredData[y] = tempTab;
              tempTab = [];
              y++;
              i=0;
          }

          if(y === totalPage) {
              filtredData[y] = tempTab;
          }
      });
    } else {
        filtredData[1] = searchedState;
    }

    return filtredData
  }

  getListCivility = (translations) => {
    return [
      { key: 'mr', text: translations.mr, value: 'Mr' },
      { key: 'mme', text: translations.mme, value: 'Mme' },
      { key: 'melle', text: translations.mlle, value: 'Melle' },
      { key: 'society', text: translations.society, value: 'Society' }
    ];
  }

  imageExists = (imageUrl, typeImage='cropped') => {
    if(imageUrl === '' || imageUrl === undefined || imageUrl === null) {
      // if(typeImage === '') {
        return this.getImageDefault(typeImage);
      // }
    }

    // let xhr = new XMLHttpRequest();
    // if(imageUrl === undefined || imageUrl === '') {
    //   return this.getImageDefault(typeImage);
    // } else {
    //   if(imageUrl.indexOf('data:image/jpeg;base64,') > -1) {
    //     return imageUrl;
    //   } else {
    //     xhr.open('HEAD', imageUrl, false);
    //     try {
    //       if(process.env.NODE_ENV === 'development') {
    //         // return imageUrls;
    //         return this.getImageDefault(typeImage);
    //       } else {
    //         xhr.send();
    //         if(xhr.status === 200) {
    //           return imageUrl;
    //         } else {
    //           return this.getImageDefault(typeImage);
    //         }
    //       }
    //     } catch(e) {
    //       return this.getImageDefault(typeImage);
    //     }
    //   }
    // }

    return imageUrl;
  }

  getImageDefault = (typeImage) => {
    if(typeImage === 'cardDashboard' || typeImage === 'cropped') {
      return imgEmptyCardDashboard;
    } else {
      return imgEmpty;
    }
  }

  getStatusBooking = (status, translations) => {
    switch(status) {
      case 'pending':
        return {status: translations.bookingsStatusPending, color: 'orange'}
      case 'enOption':
        return {status: translations.bookingsEnOption, color: 'orange'}
      case 'active':
        return {status: translations.bookingsStatusActive, color: 'green'}
      case 'passed':
        return {status: translations.bookingsStatusPassed, color: 'yellow'}
      case 'cancel':
        return {status: 'Annulée', color: 'red'}
      case 'future':
        return {status: translations.bookingsStatusFuture, color: 'blue'}
      default:
        return {status: '-', color: 'grey'}
    }
  }

  removeScript = async (el) => {
    return new Promise((resolve, reject) => {
      const scriptTags = el.getElementsByTagName('script');
      if(scriptTags.length > 0) {
          for(const script in scriptTags) {
              if(typeof scriptTags[script] === "object") {
                  if(scriptTags[script].type === "text/javascript") {
                      el.removeChild(scriptTags[script]);
                  }
              }
          }
          setTimeout(() => {
              resolve(el);
          }, 0);
      }
      resolve(el)
    })
  }

  loadScript = async (script, el, integrity = null, crossOrigin = null) => {
    
    const appScript = typeof el === 'string' ? document.querySelector(el) : el
  
    // Supprime les scripts déjà existant pour eviter une duplication
    const appScriptCleaned = await this.removeScript(appScript);                                        
  
    return new Promise(function (resolve, reject) {
      const versionUpdate = (new Date()).getTime();  
      const s = document.createElement("script");
      s.type = "text/javascript";
      s.charset = "UTF-8";
      s.src = script+'?v'+versionUpdate;
      s.async = false;
      if(integrity) s.integrity = integrity;
      if(crossOrigin) s.crossOrigin = crossOrigin;
      s.onload = () => resolve(true);
      s.onerror = () => reject(false);
      appScriptCleaned.append(s);
    });
  }

  slugify = (str) => {
    str = str.replace(/^\s+|\s+$/g, '');
  
      // Make the string lowercase
      str = str.toLowerCase();
  
      // Remove accents, swap ñ for n, etc
      var from = "ÁÄÂÀÃÅČÇĆĎÉĚËÈÊẼĔȆÍÌÎÏŇÑÓÖÒÔÕØŘŔŠŤÚŮÜÙÛÝŸŽáäâàãåčçćďéěëèêẽĕȇíìîïňñóöòôõøðřŕšťúůüùûýÿžþÞĐđßÆa·/_,:;";
      var to   = "AAAAAACCCDEEEEEEEEIIIINNOOOOOORRSTUUUUUYYZaaaaaacccdeeeeeeeeiiiinnooooooorrstuuuuuyyzbBDdBAa------";
      for (var i=0, l=from.length ; i<l ; i++) {
          str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
      }
  
      // Remove invalid chars
      str = str.replace(/[^a-z0-9 -]/g, '') 
      // Collapse whitespace and replace by -
      .replace(/\s+/g, '-') 
      // Collapse dashes
      .replace(/-+/g, '-'); 
  
      return str;
  }
}

export default new Utility();

export const errorsCodes = [
  'error_authentication_session_link_expired', 
  'error_authentication_session_type_not_valid', 
  'error_authentication_session_missing_page_type', 
  'error_authentication_session_missing_link',
  'error_authentication_session_authentication_status'
];

export const checkInErrorCodes = [
  'errorPreCheckInOldBookingFolder', 
  'error_unknown_bookingFolderId', 
  'error_authentication_session_link_expired', 
  'error_authentication_session_type_not_valid', 
  'error_authentication_session_missing_page_type', 
  'error_authentication_session_missing_link',
  'error_authentication_session_authentication_status'
]

export const createPagination = (data, maxPerPage) => {
  if (data.length > 0) {
    let i = 1;
    let page = 1;
    data.forEach(card => {
      if (i === maxPerPage) {
        page++;
        i = 1;
      }
      card.page = page;
      i++;
    })
  }
}

export const getColorCompletionRate = (completionRate) => {
  let colorCompletionRate = ""
  if (completionRate === 100) {
    colorCompletionRate = "green";
  } else if (completionRate > 33) {
    colorCompletionRate = "orange";
  } else {
    colorCompletionRate = "red";
  }

  return colorCompletionRate
}

export const getUserIdentity = (civility = null, lastName = null, society = null, firstName = null) => {
  let message = "";
  if (typeof civility === 'undefined' || civility === null) civility = '';
  if (typeof lastName === 'undefined' || lastName === null) lastName = '';
  if (typeof society === 'undefined' || society === null) society = '';
  if (typeof firstName === 'undefined' || firstName === null) firstName = '';

  let string = `${civility} ${firstName} ${lastName}`;

  if (society !== '' && lastName === '') {
    string = `${society}`;
  }

  return string;

  if ( typeof lastName !== 'undefined' && lastName !== "" ){
    let currentFirstName = typeof firstName !== 'undefined' ? firstName : "";
    let currentCivility = typeof civility !== 'undefined' ? civility : "";
    message = `${currentCivility} ${lastName} ${currentFirstName}`;
  }
  else if( typeof society !== 'undefined' && society !== "" ){
    message = society;
  }
  return message;
}

